var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"relative"}},[(_vm.showLoader)?_c('loader',{attrs:{"show":""}}):_vm._e(),(_vm.canShow)?_c('image-field',{class:_vm.getClasses(),attrs:{"src":_vm.srcVal,"max-width":"20","height":"20","contain":""},on:{"onClick":_vm.onClick}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }